import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class HeaderStyleService {
  private headerClass = ''
  private mainPositionClass = new BehaviorSubject(DEFAULT_POSITION)

  getHeaderClass(): string {
    return this.headerClass
  }

  getMainSectionClass(): Observable<string> {
    return this.mainPositionClass
  }

  setHeaderClass(className: string) {
    this.headerClass = className
    if (className == HIDE_HEADER) {
      this.mainPositionClass.next(INHERIT_POSITION)
    } else {
      this.mainPositionClass.next(DEFAULT_POSITION)
    }
  }

  setMainSectionClass(className: string) {
    this.mainPositionClass.next(className)
  }
}

export const HIDE_HEADER = 'hide-header'
export const DEFAULT_POSITION = 'fixed'
export const INHERIT_POSITION = 'inherit'
